<template>
  <div class="product-gallery">
    <!-- Imagen principal -->
    <div class="carousel-wrapper ">
      <div
        class="image-container bg-icon-primary"
        @touchstart="handleTouchStart"
        @touchmove="handleTouchMove"
        @touchend="handleTouchEnd"
      >
        <!-- Loader cuando están cargando las imágenes -->
        <div v-if="isLoadingImages" class="image-loader">
          <div class="spinner"></div>
        </div>
        
        <!-- Fondo con primary-transparent cuando no hay imagen -->
          <div v-if="!hasValidImageUrl(activeSlide) || imageLoadError" class="no-image-bg">
      </div>

      <!-- Imagen visible actual (transición suave) -->
      <picture
        v-if="hasValidImageUrl(activeSlide) && !imageLoadError"
        class="main-image-picture"
      >
        <source media="(max-width: 767px)" :srcset="currentMiniImageSrc" />
        <img
          :src="currentImageSrc"
          :alt="mainImageAlt"
          loading="eager"
          fetchpriority="high"
          width="1200"
          height="900"
          decoding="async"
          class="main-image"
          @error="handleImageError"
          @load="handleImageLoad"
        />
      </picture>

      <!-- Imagen siguiente precargada (oculta, se muestra instantáneamente al cambiar) -->
      <img
        
      
        v-if="hasValidImageUrl(nextSlide) && !imageLoadError"
        :src="nextImageSrc"
        alt=""
        aria-hidden="true"
        width="1200"
        height="900"
        loading="lazy"
        fetchpriority="low"
        decoding="async"
        class="main-image preload-only"
        @load="handlePreloadComplete"
      />
       
        <button 
          v-if="propiedadImagen.length > 1" 
          class="gallery-floating-btn btn-light"
          @click="openGallery"
          aria-label="Abrir galería"
        >
          <i class="fa-solid fa-expand"></i>
        </button>
      </div>
    </div>

    <!-- Miniaturas con navegación -->
    <div class="thumbnails-wrapper">
      <button
        class="nav-button btn-light-secondary"
         
        @click="scrollLeft"
        aria-label="Desplazar miniaturas a la izquierda"
      >
        &#10094;
      </button>

      <div class="thumbnails" ref="thumbnails">
        <div
          v-for="(image, index) in propiedadImagen"
          :key="index"
          :class="{ 'thumbnail-wrapper': true, active: activeSlide === index }"
          @click="goToSlide(index)"
        >
          <!-- Miniatura personalizada: ícono si no hay URL -->
          <div v-if="!hasValidImageUrl(index)" class="thumbnail no-image-thumb">
            <div class="circle">
              <i class="fa-solid fa-image primary"></i>
            </div>
          </div>
          <!-- Miniatura normal -->
          <img
            v-else
            :src="image.Url.substr(0, image.Url.lastIndexOf('.'))+'_mini'+image.Url.substr(image.Url.lastIndexOf('.')).trim()"
            loading="lazy"
            decoding="async"
            :alt="`Miniatura ${index + 1}`"
            width="160"
            height="120"
            class="thumbnail bg-icon-primary"
            @error="handleImageError"
          />
        </div>
      </div>

      <button
        class="nav-button btn-light-secondary"
         
        @click="scrollRight"
        aria-label="Desplazar miniaturas a la derecha"
      >
        &#10095;
      </button>
    </div>

    <!-- Modal Gallery -->
    <ModalGallery
      :show="showGallery"
      :items="galleryItems"
      :index="activeSlide"
      @close="showGallery = false"
      @prev="prevImage"
      @next="nextImage"
    />
  </div>
</template>

<script>
import ModalGallery from './ModalGallery.vue';

export default {
  name: 'ProductGallery',
  components: {
    ModalGallery
  },
  props: {
    propiedadImagen: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      activeSlide: 0,
      showGallery: false,
      imageLoadError: false,
      preloadComplete: false,
      imageTransitioning: false,
      touchStartX: 0,
      touchEndX: 0,
      swipeThreshold: 50,
      isLoadingImages: true,
    };
  },
  computed: {
    mainImageAlt() {
      const image = this.propiedadImagen?.[this.activeSlide] || {};
      return image.Alt || image.alt || image.Titulo || "Imagen principal de la propiedad";
    },
    currentImageSrc() {
      if (!this.hasValidImageUrl(this.activeSlide)) return '';
      const img = this.propiedadImagen[this.activeSlide];
      return img.Url.substr(0, img.Url.lastIndexOf('.')) + '_std' + img.Url.substr(img.Url.lastIndexOf('.')).trim();
    },
    currentMiniImageSrc() {
      if (!this.hasValidImageUrl(this.activeSlide)) return '';
      const img = this.propiedadImagen[this.activeSlide];
      return img.Url.substr(0, img.Url.lastIndexOf('.')) + '_mini' + img.Url.substr(img.Url.lastIndexOf('.')).trim();
    },
    nextSlide() {
      return (this.activeSlide + 1) % this.propiedadImagen.length;
    },
    nextImageSrc() {
      if (!this.hasValidImageUrl(this.nextSlide)) return '';
      const img = this.propiedadImagen[this.nextSlide];
      return img.Url.substr(0, img.Url.lastIndexOf('.')) + '_mini' + img.Url.substr(img.Url.lastIndexOf('.')).trim();
    },
    galleryItems() {
      return this.propiedadImagen.map(img => ({
        url: img.Url ? img.Url.substr(0, img.Url.lastIndexOf('.')) + '_std' + img.Url.substr(img.Url.lastIndexOf('.')).trim() : '',
        type: img.Url?.toLowerCase().endsWith('.mp4') ? 'video' : 'image'
      }));
    }
  },
  mounted() {
          // this.$root.$isLoading(false);

    this.$nextTick(() => {
      this.scrollToActiveThumbnail();
    });
          // this.$root.$isLoading(true);

  },
  watch: {
    propiedadImagen: {
      handler(newVal) {
        this.activeSlide = 0;
        this.imageLoadError = false;
        this.isLoadingImages = Boolean(newVal && newVal.length > 0);
      },
      immediate: true
    },
    activeSlide() {
      this.imageLoadError = false;
      this.isLoadingImages = this.hasValidImageUrl(this.activeSlide);
      this.scrollToActiveThumbnail();
    },
  },
  methods: {
    openGallery() {
      this.showGallery = true;
    },
    prevImage() {
      if (this.activeSlide > 0) {
        this.activeSlide--;
      } else {
        this.activeSlide = this.propiedadImagen.length - 1;
      }
    },
    nextImage() {
      if (this.activeSlide < this.propiedadImagen.length - 1) {
        this.activeSlide++;
      } else {
        this.activeSlide = 0;
      }
    },
    hasValidImageUrl(index) {
      const url = this.propiedadImagen[index]?.Url;
      return url && typeof url === 'string' && url.trim() !== '';
    },

    handleImageError() {
      this.imageLoadError = true;
      this.isLoadingImages = false;
    },

    handleImageLoad() {
      this.preloadComplete = true;
      this.isLoadingImages = false;
    },

    handlePreloadComplete() {
      this.preloadComplete = true;
    },

    handleTouchStart(e) {
      this.touchStartX = e.changedTouches[0].screenX;
    },

    handleTouchMove(e) {
      this.touchEndX = e.changedTouches[0].screenX;
    },

    handleTouchEnd() {
      const diff = this.touchStartX - this.touchEndX;
      if (Math.abs(diff) > this.swipeThreshold) {
        if (diff > 0) {
          this.nextImage();
        } else {
          this.prevImage();
        }
      }
      this.touchStartX = 0;
      this.touchEndX = 0;
    },

    goToSlide(index) {
      if (index >= 0 && index < this.propiedadImagen.length) {
        this.activeSlide = index;
      }
    },

    scrollLeft() {
      this.$refs.thumbnails?.scrollBy({ left: -120, behavior: 'smooth' });
      if (this.activeSlide > 0) {
        this.activeSlide--;
      } else {
        this.activeSlide = this.propiedadImagen.length - 1;
      }
    },

    scrollRight() {
      this.$refs.thumbnails?.scrollBy({ left: 120, behavior: 'smooth' });
      if (this.activeSlide < this.propiedadImagen.length - 1) {
        this.activeSlide++;
      } else {
        this.activeSlide = 0;
      }
    },

    scrollToActiveThumbnail() {
      const thumbnails = this.$refs.thumbnails;
      if (!thumbnails) return;

      const activeThumb = thumbnails.children[this.activeSlide];
      if (activeThumb) {
        const containerRect = thumbnails.getBoundingClientRect();
        const thumbRect = activeThumb.getBoundingClientRect();
        const scrollOffset = thumbRect.left - containerRect.left - (containerRect.width - activeThumb.offsetWidth) / 2;

        thumbnails.scrollTo({
          left: thumbnails.scrollLeft + scrollOffset,
          behavior: 'smooth',
        });
      }
    },

  },
};
</script>

<style scoped>
/* Ocultar scrollbars */
.thumbnails {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.thumbnails::-webkit-scrollbar {
  display: none;
}

/* Galería principal */
.product-gallery {
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.carousel-wrapper {
  width: 100%;
  margin-bottom: 1rem;
}

.image-container {
  width: 100%;
  aspect-ratio: 4 / 3;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  border-radius: 8px;
  overflow: hidden;
  outline: none;
  box-shadow: none;
  border: none;
  position: relative;
}

.main-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  transition: opacity 0.3s ease;
}

.main-image-picture {
  display: block;
  width: 100%;
  height: 100%;
}

.main-image.fade-in {
  animation: fadeIn 0.3s ease;
}

.preload-only {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
  pointer-events: none;
  z-index: -1;
}

@keyframes fadeIn {
  from { opacity: 0.7; }
  to { opacity: 1; }
}

/* Ícono en imagen principal (centrado y grande) */
.no-image {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.no-image-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--primary-transparent);
  display: flex;
  justify-content: center;
  align-items: center;
}
.circle {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Miniaturas */
.thumbnails-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.thumbnails {
  display: flex;
  overflow-x: auto;
  gap: 0.75rem;
  padding: 0.5rem 0;
  scroll-behavior: smooth;
  justify-content: center;
}

.thumbnail-wrapper {
  flex: 0 0 auto;
  width: 80px;
  height: 60px;
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 6px;
  transition: border-color 0.2s ease, transform 0.2s ease;
  display: flex;
  justify-content: center;
  align-items: center;
}

.thumbnail-wrapper:hover {
  transform: scale(1.05);
}

.thumbnail-wrapper.active,
.thumbnail-wrapper:hover {
  border-color: var(--primary);
}

.thumbnail {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  border-radius: 4px;
}

/* Ícono en miniatura */
.no-image-thumb {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--primary);
  border-radius: 4px;
}

.no-image-thumb .circle {
  width: 50px;
  height: 50px;
  background-color: var(--white);
  color: var(--primary);
}

/* Botones de navegación */
.nav-button {
  border-radius: 50%;
  width: 46px;
  height: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  cursor: pointer;
  transition: background-color 0.2s;
  flex-shrink: 0;
}

.nav-button:hover {
  background-color: #f1f3f5;
}

/* Móviles */
@media (max-width: 576px) {
  .image-container {
    aspect-ratio: 3 / 2;
  }

  .circle {
    width: 80px;
    height: 80px;
  }

  .thumbnail-wrapper {
    width: 70px;
    height: 50px;
  }

  .no-image-thumb .circle {
    width: 40px;
    height: 40px;
  }

  .nav-button {
    width: 32px;
    height: 32px;
    font-size: 16px;
  }

  .gallery-floating-btn {
    width: 25px;
    height: 25px;
    font-size: 18px;
    color: white !important;
  }

  .gallery-floating-btn span {
    font-size: 10px;
    color: white !important;
  }
}

.gallery-floating-btn {
  position: absolute;
  bottom: 15px;
  right: 15px;
  /* background: rgba(0, 0, 0, 0.6); */
  border: none;
  border-radius: 10px;
  width:40px;
  height: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  /* color: white !important; */
  gap: 2px;
  transition: background-color 0.2s, transform 0.2s;
}

.gallery-floating-btn:hover {
  transform: scale(1.1);
}

.gallery-floating-btn i {
  font-size: 20px;
}

.gallery-floating-btn span {
  font-size: 11px;
  font-weight: 600;
}

.image-loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: color-mix(in srgb, var(--primary-dark), transparent 0%);
  z-index: 5;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
